import PropTypes from "prop-types";
import { useState } from "react";
import MasterExternalFoodSection from "./components/MasterExternalFoodSection";
import MasterFoodLibraryHeader from "./components/MasterFoodLibraryHeader";
import MasterFoodLibraryTable from "./components/MasterFoodLibraryTable";
import MasterMealsLibraryTable from "./components/MasterMealsLibraryTable";

const MasterFoodLibrary = ({ locals, query }) => {
  const { foodsByCoach, mealsByCoach } = locals;
  const urlRecipeId =
    query?.recipeId ||
    query?.recipe ||
    query?.detailId ||
    (typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("recipeId") ||
        new URLSearchParams(window.location.search).get("recipe") ||
        new URLSearchParams(window.location.search).get("detailId")
      : null);

  const initialState = {
    section:
      query?.section === "external" || urlRecipeId
        ? "external"
        : ["meal", "external"].includes(query?.section)
          ? query.section
          : "food",
    search: "",
  };
  const [state, setState] = useState(initialState);

  const { section, search } = state;

  const filteredFoods = foodsByCoach.filter(({ name }) =>
    name.toLowerCase().includes(search.toLowerCase())
  );

  const filteredMeals = mealsByCoach.filter(({ name }) =>
    name.toLowerCase().includes(search.toLowerCase())
  );

  /**
   * Function to update the states
   * @param {*} newState
   * @returns
   */
  const updateState = (newState) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  return (
    <main className="main-master-food-library">
      <MasterFoodLibraryHeader
        section={section}
        updateState={updateState}
        search={search}
      />
      {section === "food" && <MasterFoodLibraryTable data={filteredFoods} />}
      {section === "meal" && <MasterMealsLibraryTable data={filteredMeals} />}
      {section === "external" && (
        <MasterExternalFoodSection
          search={search}
          initialRecipeId={urlRecipeId}
          onSearchChange={(value) => updateState({ search: value })}
          onClearSearch={() => updateState({ search: "" })}
          onOpenCustom={() => updateState({ section: "food", search: "" })}
        />
      )}
    </main>
  );
};

MasterFoodLibrary.propTypes = {
  locals: PropTypes.object,
  query: PropTypes.object,
};

export default MasterFoodLibrary;
